// extracted by mini-css-extract-plugin
export default {"title":"title_title__HznUv","module":"title_module__vzoMl","loader":"title_loader__1jQW+","title__text":"title_title__text__EhOcM"};